import { TOGGLE_SIDEBAR, TOGGLE_MOBILE_ADMIN } from '../types'

const INITIAL_STATE = {
  sidebarShow: true,
  unfoldable: false,
  mobileAdminEnabled: false,
}

const appReducer = (state = INITIAL_STATE, { type, ...rest }) => {
  switch (type) {
    case TOGGLE_SIDEBAR: {
      const nextState = { ...state, ...rest }

      if (
        nextState.sidebarShow === state.sidebarShow &&
        nextState.unfoldable === state.unfoldable &&
        nextState.mobileAdminEnabled === state.mobileAdminEnabled
      ) {
        return state
      }

      return nextState
    }
    case TOGGLE_MOBILE_ADMIN:
      return { ...state, mobileAdminEnabled: rest.enabled }
    default:  
      return state
  }
}

export default appReducer
